"use client";
import { memo } from "react";
import { motion } from "framer-motion";
import { SuitabilityQuestionOption } from "@/type/commonTypes";

function SuitabilitySelectedCard({ option }: { option: SuitabilityQuestionOption }) {
  return (
    <motion.div
      className="w-full ml-auto max-w-fit bg-[#4483FE] text-left px-4 py-2.5 rounded-xl overflow-hidden"
      initial={{ maxWidth: 0, padding: 0, opacity: 0 }}
      animate={{ maxWidth: "fit-content", padding: "10px 16px", opacity: 1 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
    >
      <p className="max-w-72 sm:max-w-300 text-2xs xs:text-2sm font-semibold text-white">{option.label}</p>
    </motion.div>
  );
}

export default memo(SuitabilitySelectedCard);
